import React, { useState, useEffect } from 'react';
import { Form, Button,OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMicrocredentialTypes } from '../actions/typeActions';
import { createRequest } from '../actions/requestActions';
import arrowRightImage from '../assets/arrow-small-right.png';
import { useNavigate } from 'react-router-dom';
import AttachmentButton from './AttachmentButton';
import {RequestStatus} from '../enums/requestStatus';
import mcProceso from '../assets/mcProceso.png';
import ZoomImage from './zoomImg';
import AttachmentButtonPDF from './AttachmentButtonPDF';
import { InfoCircle } from 'react-bootstrap-icons';

const RequestForm = () => {   
    const [projectName, setProjectName] = useState('');
    const [selectedMicrocredential, setSelectedMicrocredential] = useState('');
    const [recipientsDescription, setProjectRecipients] = useState('');
    const [learningResults, setLearningResults] = useState('');
    const [contentResults, setContentResults] = useState('');
    const [projectRelevance, setProjectRelevance] = useState('');
    const [grantCredits, setGrantCredits] = useState(false);
    const [attachment, setAttachment] = useState(null);
    const dispatch = useDispatch();
    const { microcredentials, loading, error } = useSelector((state) => state.types);
    const { userInfo } = useSelector(state => state.user);
    const navigate = useNavigate();
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [fileName,setFileName] = useState(null);
    const [fileNamePDF, setFileNamePDF] = useState(null);
    const [representativesSP, setrepresentativesSP] = useState('');
    const [carreras, setCarreras] = useState([]);
    const [asignaturas, setAsignaturas] = useState([]);
    const [fileError, setFileError] = useState(false);
    const [cvError, setCVError] = useState(false);
    
    const handleBack = () => {
        navigate('/backoffice'); 
    };

    useEffect(() => {
        dispatch(fetchMicrocredentialTypes(userInfo));
    }, [dispatch]);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleFileSelect  = (file) => {
        setAttachment(file); // Get the selected file
        setFileError(false); // Limpiar error si selecciona archivo
    };
    
    const handFilePDFSelect = (file) =>
    {
      setFileNamePDF(file);
      setCVError(false); // Limpiar error si selecciona archivo
    }


    const handleSubmit = (e) => {
        e.preventDefault();
        // Validar que haya archivo adjunto para mapeo
        if (!attachment) {
            setFileError(true);
            return;
        }
        setFileError(false);

        if (!fileNamePDF){
        setCVError(true);
        return;
        }
        setCVError(false);

        let creditosOtorgados = '';
        if (carreras && carreras.length > 0) {
            creditosOtorgados = carreras;
        } else if (asignaturas && asignaturas.length > 0) {
            creditosOtorgados = asignaturas;
        }
        const requestData = {
            resultadosContenido: contentResults, 
            resultadosAprendizaje: learningResults,
            pertinencia: projectRelevance, 
            usuario: {
                EntityId: userInfo.userid
            },
            microcredencial: {
                Id: selectedMicrocredential
            },
            
            destinatarios: recipientsDescription,
            estado:{
                Id: RequestStatus.Pendiente.id
            },
            nombre: projectName,
            otorgaCreditos: grantCredits,
            representantesSectorSocioProductivo: representativesSP,
            creditosOtorgados: creditosOtorgados,
        };
        dispatch(createRequest(requestData, attachment,fileNamePDF,userInfo, navigate, false));
    };
    const handleImageClick = () => {
        if (windowWidth < 700) {
            setIsModalOpen(true);
        }
    };

    const handleCloseModal = () => setIsModalOpen(false);

    return (
        <div className='contReduce'style={{marginBottom:'20px'}}>
            <section className="container1">                
                <a className="btn_back" onClick={handleBack}>
                    Volver al home
                </a>
                <section>
                    <div className="bienvenida2">
                        <div className="first_col1">
                            <h2>¿Querés ingresar al mundo de las microcredenciales?</h2>
                            <p>Para dar inicio al proceso, completá esta solicitud de preautorización considerando las  
                            <a href="https://uai.edu.ar/media/135686/orientaciones-para-la-presentaci%C3%B3n-y-dise%C3%B1o-de-microcredenciales-2-1.pdf" style={{ color: '#F20A61', textDecoration: 'underline', fontWeight: 'bold,',marginLeft:'3px' }}>
                            orientaciones del lineamiento
                            </a>

                            </p>
                            {/* Enlace temporal como referencia */}
                            
                            <div className="alcance_content">
                                <img id='arrow' src={arrowRightImage} alt="" />
                                <p>Te responderemos en un plazo máximo de 15 días hábiles (enero, receso vacacional).</p>
                            </div>
                           {/*
                           <div className='imgProcess'>
                                <img src={mcProceso} style={{ width: '90%' }} alt="" class="img-fluid zoom-image" />
                            </div>
                            */} 
                           <div className="imgProcess" id='imgProcessBig'
                            style={{
                             display:"flex",
                             flexDirection:"column",
                             alignItems:"center",
                             justifyContent:"center",
                             marginBottom:"-30px",
                             height:"auto",
                             overflow:"hidden"
                            }}
                            >
                             <ZoomImage />
                            </div> 
                            <div className='imgProcess' id='imgProcessSmall'>
                                <img 
                                    src={mcProceso} 
                                    alt="Proceso" 
                                    className="zoom-image"
                                    onClick={handleImageClick}
                                    style={{ width: '90%' }}
                                />
                            </div>
                            <p
                            className="mt-3 text-center text-muted"
                            style={{maxWidth: "80%",marginLeft:"10px",fontSize:"1.2rem" }}  
                            >
                            La presentación de este proyecto se realiza en el marco de una convocatoria y por lo tanto queda
                            sujeta. Tenga en cuenta que deberá completar el diseño de la propuesta de la micro credencial
                            conforme a las orientaciones del lineamiento en un formulario en línea.
                            </p>
                        </div>
                        <div className="second_col1">
                            <div className="frame-parent">
                                <Form onSubmit={handleSubmit}>
                                    <Form.Group className="tipo-de-credencial-parent mb-3" controlId="projectName">
                                        <Form.Label className='nombre'>Nombre del proyecto</Form.Label>
                                        <Form.Control type="text" maxLength="99" placeholder="Escriba el nombre del proyecto" required value={projectName} onChange={(e) => setProjectName(e.target.value)} />
                                    </Form.Group>                                   
                                    <Form.Group className="tipo-de-credencial-parent mb-3" controlId="selectedMicrocredential">
                                        <Form.Label className='nombre'>Tipo de microcredencial</Form.Label>
                                        <Form.Select value={selectedMicrocredential} onChange={(e) => setSelectedMicrocredential(e.target.value)} required>
                                            <option value="">Seleccione el tipo de microcredencial</option>
                                            {microcredentials.map((microcredential) => (
                                                <option key={microcredential.Id} value={microcredential.Id}>{microcredential.tipoNombre}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                    <Form.Group className="tipo-de-credencial-parent mb-3" controlId="learningResults">
  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
    <Form.Label className="nombre mb-0">Resultados de Aprendizaje</Form.Label>
                    <OverlayTrigger
                     placement="top"
                    overlay={
                    <Tooltip id="tooltip-info" className="tooltip-wide">
                    {`Redacte los resultados de aprendizaje (RA) que el estudiante habrá logrado al finalizar el curso. Formule un resultado de aprendizaje global y detalle tres o cuatro resultados específicos que permitan operacionalizar el resultado final. El resultado global deberá dar cuenta del desempeño final evidenciado en una producción.

                    Tenga en cuenta las siguientes consideraciones para la elaboración de los RA:

                    - La formulación debe expresar en forma clara y precisa qué se espera que demuestre, conozca, o sepa hacer el cursante al finalizar el proceso formativo.

                    - La formulación de cada RA contiene un verbo que expresa la actuación esperada, un objeto sobre el que recae dicha actuación y el contexto o condición de calidad con la que se ejecutará.

                    - Considerar el nivel de profundidad/dominio que tendrá el RA; para ello, tener en cuenta el destinatario, si articula con otra MC o con una macro credencial (carrera de pregrado, grado o posgrado).`}
                    </Tooltip>
                }
                >
                <span
                    style={{
                    color: 'hotpink',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    fontSize: '0.75rem',
                    border: '1px solid hotpink',
                    borderRadius: '50%',
                    padding: '1px 5px',
                    display: 'inline-block',
                    lineHeight: '1',
                    }}
                >
                    i
                </span>
                </OverlayTrigger>
                </div>

                <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Describa los Resultados de Aprendizaje que espera que logren los participantes"
                    required
                    value={learningResults}
                    onChange={(e) => setLearningResults(e.target.value)}
                />
                </Form.Group>
                                    <Form.Group className="tipo-de-credencial-parent mb-3" controlId="projectName">
                                        <Form.Label className='nombre'>Mapeo de contenidos</Form.Label>
                                        <Form.Control
                                          as="textarea"
                                          rows={3}
                                          placeholder="Realice y entregue un mapeo (diagrama/detalle) de los contenidos en relación con los Resultados de aprendizaje" 
                                          required value={contentResults} 
                                          onChange={(e) => setContentResults(e.target.value)} />
                                        {/* <Form.Label className='nombre'>Adjuntar documento</Form.Label>
                                        <Form.Control type="file" accept=".pdf,.jpg,.png" onChange={handleAttachmentChange} /> */}
                                    </Form.Group> 
                                    <AttachmentButton onClick onFileSelect={handleFileSelect} acceptType="*"/>
                                    {fileError && (
                                        <div style={{ color: 'red', padding: '0px 0px 10px', display: 'flex', alignItems: 'center', fontSize: '0.95em', gap: '6px' }}>
                                           
                                            Es obligatorio adjuntar un archivo de mapeo de contenidos
                                        </div>
                                    )}
                                    <Form.Group className="tipo-de-credencial-parent mb-3" controlId="projectName">
                                        <Form.Label className='nombre'>
                                        Destinatarios del proyecto de microcredencial
                                        </Form.Label>
                                        <Form.Control 
                                         as="textarea"
                                         rows={3}
                                         placeholder="Describa los destinatarios del proyecto de microcredencial"
                                         required value={recipientsDescription}
                                         onChange={(e) => setProjectRecipients(e.target.value)} />
                                    </Form.Group>                                    
                                    <Form.Group className="tipo-de-credencial-parent mb-3" controlId="projectDescription">
                                        <Form.Label className='nombre'>Pertinencia del proyecto en términos de las demandas sociales/profesionales a las que atiende</Form.Label>
                                        <Form.Control as="textarea" rows={3} placeholder="Explique la pertinencia del proyecto. Incluya datos y referencias que sustentan la pertinencia de la propuesta" required value={projectRelevance} onChange={(e) => setProjectRelevance(e.target.value)} />
                                    </Form.Group>
                                    <Form.Group className="tipo-de-credencial-parent mb-3" controlId="projectDescription">
                                         <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            <Form.Label className="nombre mb-0">Participación del sector socio-productivo</Form.Label>
                                                            <OverlayTrigger
                                                            placement="top"
                                                            overlay={
                                                            <Tooltip id="tooltip-info" className="tooltip-wide">
                                                            {`Especifique cuál será la modalidad de participación (partner, sponsor, prácticas y pasantías, capacitación corporativa, representante valioso del sector socio-productivo).
                                                            Detalle de las modalidades de participación: 

                                                            Sponsor (Patrocinador): Apoya financieramente el desarrollo y lanzamiento de microcredenciales, obteniendo visibilidad y participación directa en el diseño de los programas.  

                                                            •	Prácticas y Pasantías: Facilita espacios de aprendizaje práctico para estudiantes y captar talento especializado.  

                                                            •	Capacitación Corporativa: Brinda formación a empleados en áreas clave para fortalecer la competitividad empresarial.  

                                                            •	Partner (Alianza Estratégica): Co-crea microcredenciales adaptadas a las necesidades de la industria y participar en el diseño de contenido educativo. `}
                                                            </Tooltip>
                                                        }
                                                        >
                                                        <span
                                                            style={{
                                                            color: 'hotpink',
                                                            cursor: 'pointer',
                                                            fontWeight: 'bold',
                                                            fontSize: '0.75rem',
                                                            border: '1px solid hotpink',
                                                            borderRadius: '50%',
                                                            padding: '1px 5px',
                                                            display: 'inline-block',
                                                            lineHeight: '1',
                                                            }}
                                                        >
                                                            i
                                                        </span>
                                                        </OverlayTrigger>
                                                        </div>
                                        <Form.Control as="textarea" rows={3} placeholder="Explicite quienes serán los representantes del sector socio-productivo con los que establecerá alianza para desarrollar el proyecto. Indique nombre y apellido del referente y el cargo que ocupa dentro de la empresa/organización"  required value={representativesSP} onChange={(e) => setrepresentativesSP(e.target.value)} />
                                    </Form.Group>
                                    <Form.Group className="tipo-de-credencial-parent mb-3" controlId="projectName">
                                        <Form.Label className='nombre'> 
                                         CV de los profesionales que desarollaran la propuesta
                                        </Form.Label>
                                        <AttachmentButtonPDF onFileSelect={handFilePDFSelect} acceptType="application/pdf"/>
                                        {cvError && (
                                           <div style={{ color: 'red', padding: '0px 0px 10px', display: 'flex', alignItems: 'center', fontSize: '0.95em', gap: '6px' }}>
                                                Es obligatorio adjuntar un archivo con el CV de los profesionales que desarrollarán la propuesta
                                            </div> 
                                        )}
                                    </Form.Group>
                                    {selectedMicrocredential === 'b14f2a31-9c3e-4a88-9a29-c4c29aa38e25' ? (

                                    <Form.Group className="tipo-de-credencial-parent mb-3" controlId="projectName">
                                        <Form.Label className="nombre">Créditos académicos</Form.Label>
                                        <Form.Control
                                        as="textarea"
                                        type="text"
                                        maxLength="99"
                                        placeholder="Especifique la/s asignatura/s y carrera/s de la UAI a las que la MC  otorgará créditos. Recuerde que deben tener RA equivalentes."
                                        required
                                        value={asignaturas}
                                        onChange={(e) => setAsignaturas(e.target.value)}
                                        />
                                    </Form.Group>
                                    ) :selectedMicrocredential === '249408eb-6f9f-421b-8b30-c26ac417f4cd' ? (

                                    <Form.Group className="tipo-de-credencial-parent mb-3" controlId="projectName">
                                        <Form.Label className="nombre">Créditos académicos</Form.Label>
                                        <Form.Control
                                        as="textarea"
                                        type="text"
                                        maxLength="99"
                                        placeholder="Especifique para qué carrera/s otorgará créditos (trayecto flexible). Recuerde que los RA de la MC deben aportar a competencias del perfil de egreso."
                                        required
                                        value={carreras}
                                        onChange={(e) => setCarreras(e.target.value)}
                                        />
                                    </Form.Group>
                                    ) : null}   
                                    <div className='center-container'>
                                        <Button variant="primary" type="submit" disabled={loading}>Enviar solicitud</Button>
                                    </div>
                                </Form>
                                {loading && <p>Cargando...</p>}
                                {error && <p>Error: {error}</p>}
                            </div>
                        </div>
                    </div>
                </section>
            </section>
            {isModalOpen && (
                <div className="modal-overlay" onClick={handleCloseModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <img src={mcProceso} alt="Expanded" className="modal-image" />
                        <button style={{width:'30px',height:'30px',textAlign:'center',alignItems:'center'}} className="modal-close" onClick={handleCloseModal}>X</button>
                    </div>
                </div>
            )}

        </div>
    );
};

export default RequestForm;
